// src/stores/auth.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SessionUser } from '@fixflow/shared-types';

interface AuthState {
  user: SessionUser | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: SessionUser, token: string) => void;
  updateUser: (patch: Partial<SessionUser>) => void;
  switchStore: (user: SessionUser, token: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setAuth: (user, token) => set({ user, token, isAuthenticated: true }),
      updateUser: (patch) =>
        set((state) =>
          state.user ? { user: { ...state.user, ...patch } } : state,
        ),
      switchStore: (user, token) => set({ user, token, isAuthenticated: true }),
      clearAuth: () => set({ user: null, token: null, isAuthenticated: false }),
    }),
    { name: 'fixflow-auth' },
  ),
);
